import ProjectService from '../../project.service.js';
import Service from '@/service/index.js';
import Pagination from '@/components/pagination/index.vue';
import {transactionProjectStatus} from '@/utils/mixins/transaction-project-status.js';
// import { errorMessage, successMessage } from '@/utils/message.js';
import Payment from '@/components/payment/payment.vue';
import { changeSkin } from '@/utils/common.js';
export default {
  components: {
    Pagination,
    Payment
  },
  mixins: [transactionProjectStatus],
  data() {
    return {
      projectStatusArr: [],
      projectTypeArr: [],
      tradeTypeArr: [],
      total: 0,
      currentPage: 1,
      pageSize: 5,
      tableList: [],
      showPayment: false,
      currentProjectId: ''
    };
  },
  created() {
    // BATCH_STATUS  批量项目状态
    const arr = [
      ['projectStatusArr', 'BATCH_STATUS'],
      ['projectTypeArr', 'PROJECT_TYPE'],
      ['tradeTypeArr', 'TRADE_TYPE'],
      ['projectSubTypeArr', 'BACTH_PROJECT_TYPE']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          this[value[0]] = res.data;
        }
      });
    });
    this.getRollOutProjectList();
  },
  computed: {
  },
  methods: {
    changeSkin,
    // 项目类型两级拼接
    projectTypeText (projectItem) {
      if (!this.projectTypeArr.length) {return ''; }
      const obj = this.projectTypeArr.find(item => item.code === String(projectItem.projectType));
      if (obj) {
        // console.log(projectItem, this.projectSubTypeArr);
        const subObj = this.projectSubTypeArr.find(item => item.code === String(projectItem.projectSubType));
        if (subObj) {
          return obj.value + ' · ' + subObj.value;
        } else {
          return obj.value;
        }
      } else {
        return '';
      }
    },
    // 获取发布项目列表
    getRollOutProjectList(page){
      if (page) {
        this.currentPage = page.pageNo;
        this.pageSize = page.pageSize;
      }
      ProjectService.getBatchOutProjectList(this.currentPage, this.pageSize).then(res => {
        if (res && res.code === '0') {
          // console.log(res);
          this.total = res.data.total;
          this.tableList = res.data.list;
        }
      });
    },
    goToDetail (item) {
      window.open(window.location.origin + '/#/person-center/project/batch-out-project/detail?id=' + item.id + '&specialStatus=' + item.specialStatus);
    },
    goToeditor (item) {
      window.open(window.location.origin + '/#/publish-project/project-batchinfo?id='+item.id+'&tradeType=3');
    },
    // 上传公告照片
    uploadAnnouncementImg (item) {
      this.$router.push('/person-center/project/batch-out-project/upload-announcement-image?id=' + item.id);
    },
    batchProject () {
      this.$store.commit('SET_TRADE_TYPE', 3);
      window.open(window.location.origin + '/#/publish-project/project-batchinfo?tradeType=3');
    }
  }
};
